import { Channel } from 'api/ChannelsAPI';
import { MessageType } from 'api/MessageTypeAPI';
import { DEFAULT_MESSAGE_TYPE_METADATA } from '../constants';
import { isEmailMarketingChannel, isFrequencyCapChannelV2 } from './channels';

export const createFrequencyCapMetadata = (
  frequencyCap: MessageType['frequencyCap'],
  channel: Channel,
  featureFlags: { [key: string]: boolean },
): string => {
  const {
    FrequencyCapping = false,
    FrequencyCappingV2 = false,
    FrequencyCappingMessageType = false,
  } = featureFlags;

  /** If FrequencyCappingMessageType (V3) is on, hide this metadata; All metadata has been moved to /settings/frequencyManagement */
  if (FrequencyCappingMessageType) return '';

  const isEmailMarketing = isEmailMarketingChannel(channel);
  const isChannelEnabledV2 = isFrequencyCapChannelV2(channel);
  const isIgnoreFrequencyCap = !!frequencyCap?.ignoreFrequencyCap && !!channel?.frequencyManagement;

  if (FrequencyCappingV2) {
    return isChannelEnabledV2 && isIgnoreFrequencyCap ? DEFAULT_MESSAGE_TYPE_METADATA : '';
  }

  if (FrequencyCapping && isEmailMarketing) {
    // Taking extreme caution with the added checks
    // BE sets these values as -1 or 0 if they aren't set explicitly
    const isUnlimited =
      !frequencyCap || frequencyCap.numMessagesInPeriod < 1 || frequencyCap.periodDays < 1;
    const numMessages = frequencyCap?.numMessagesInPeriod.toLocaleString();
    const perDay = frequencyCap?.periodDays.toLocaleString();

    return isUnlimited
      ? DEFAULT_MESSAGE_TYPE_METADATA
      : `Cap sends at ${numMessages} messages in a ${perDay} day period`;
  }

  /** V3 (FrequencyCappingMessageType) case will fallback to empty string */
  return '';
};

export const createRateLimitMetadata = (rateLimitPerMin: MessageType['rateLimitPerMin']) =>
  !rateLimitPerMin
    ? 'Send messages as quickly as possible'
    : `Send max ${rateLimitPerMin.toLocaleString()} messages per minute`;
